export const LOCALES = {
    PORTUGUESE: 'pt-BR',
    ENGLISH: 'en-US',
    SPANISH: 'es-ES'
}
